import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  BILL_PAY_RECHARGE_PLANS,
  LOAD_BALANCE_VALIDATE_TRANSFER,
} from '../../services/common/endpoints';
import { callQueryapi } from '../../services/http/callapi';
import Loadingcomponent from '../loader/loadingcomponent';
import { GTMScreenView } from '../../analytics/GoogleTagManager';
import {CT_Events} from "../../../src/analytics/CTEvents";

const LoadBalance = ({ pmsitem }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [mobileNumber, setMobileNumber] = useState('');
  const [amountVal, setAmountVal] = useState('');
  const [validityNote, setValidityNote] = useState('');
  const [amountFieldError, setAmountFieldError] = useState(null);
  const {CT_ScreenView} = CT_Events();
  const customerprofile = useSelector(
    (state) => state?.userdata?.value?.customerprofile
  );
  let msisdn = customerprofile?.Msisdn;
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const Msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);

  const { data: { data } = {} } = useQuery(
    [
      'bill-pay-recharge-plans',
      BILL_PAY_RECHARGE_PLANS.url,
      BILL_PAY_RECHARGE_PLANS.data,
      {},
    ],
    { retry: false, cacheTime: 300000, staleTime: 300000 }
  );

  const validateLoadBalance = useMutation(
    (req) =>
      callQueryapi({
        queryKey: [
          {},
          LOAD_BALANCE_VALIDATE_TRANSFER,
          {
            msisdn: req?.msisdn,
            amount: req?.amount,
          },
        ],
      }),
    {
      onSuccess: (udata) => {
        if (udata?.data?.status === '0') {
          navigate('/XpessPay', {
            state: {
              amount: amountVal,
            },
          });
        } else {
          if (udata?.data?.infomsg === 'amount') {
            setAmountFieldError(udata?.data?.message);
          }
        }
      },
    }
  );

  useEffect(()=>{
    try{
      GTMScreenView("load-balance", Msisdn, logintype);
    }catch{}
    try{
      CT_ScreenView()
    }catch{}
  }, [])
  
  useEffect(() => {
    if (msisdn) {
      setMobileNumber(
        msisdn.substring(0, 3) === '965' ? msisdn.substr(3) : msisdn
      );
    }
    //eslint-disable-next-line
  }, [customerprofile]);

  useEffect(() => {
    if (data) {
      const defaulyPriceData = data?.response.filter((v, k) => {
        return v.isdefault === 'T';
      });
      if (defaulyPriceData) {
        setAmountVal(`${defaulyPriceData[0].defaultamount}`);
        setValidityNote(defaulyPriceData[0].validity);
      }
    }
  }, [data]);

  const handleAmountChange = (e) => {
    let text = e.target.value;

    if (text.length === 0) {
      setAmountFieldError(t('pea'));
    } else {
      setAmountFieldError('');
    }

    if (text.length > 4) {
      return;
    } else {
      //eslint-disable-next-line
      let validStr = text.replace(/[^0-9\.]/g, '');
      if (validStr.split('.').length > 2) {
        validStr = text.replace(/\.+$/, '');
      }

      setAmountVal(validStr);

      setValidityNote('');
      for (let a = 0; a < data?.response.length; a++) {
        if (
          parseFloat(text) >= parseFloat(data?.response[a].startprice) &&
          parseFloat(text) <= parseFloat(data?.response[a].endprice)
        ) {
          setValidityNote(data?.response[a].validity);
          break;
        }
      }
    }
  };

  const handleContinue = () => {
    if(!amountVal){
      setAmountFieldError(t('pea'));
      return;
    }

    validateLoadBalance.mutate({
      msisdn: msisdn.substring(0, 3) === '965' ? msisdn : `965${msisdn}`,
      amount: amountVal,
    });
  };

  return (
    <div className="pse_sm mt-4">
      <h2 class="mb-2 page_title_v1">{pmsitem?.metadata?.title}</h2>
      <p class="support_text mb-0">{pmsitem?.metadata?.desc}</p>

      <div className="recharge_sec overflow-auto mb-5 pb-5 mt-5">
        <div>
          <div className="d-flex flex-row justify-content-between gap-2 mb-2">
            <div className="form-group width50">
              <label className="control-label">{t('mobilenumber')}</label>
              <input
                type="text"
                className="form-control"
                value={mobileNumber}
                disabled={true}
              />
            </div>
            <div className="form-group width35">
              <label className="control-label">{t('amount')}</label>
              <div className="input_icon left-icon">
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  value={amountVal}
                  onChange={handleAmountChange}
                />
                <button>{t('kd')}</button>
              </div>

              <label className="dark_gray_color mt-1 font12 dir-ltrl">
                {validityNote}
              </label>

              {amountFieldError && (
                <span className="error_msg mt-0">{amountFieldError}</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <section className="fixed_footer">
        <div className="fixed_footer_container">
          <div className="mb-3 flex_grp_align_center">
            <div>
              <img
                src={process.env.PUBLIC_URL + '/assets/images/details-icon.svg'}
                width={40}
                alt=""
                title=""
              />
            </div>

            <div className="d-flex flex-column ms-2">
              <h4 className="primary_14 mb-1">{t('Amount')}</h4>
              <p className="support_text mb-0">
                {t('total')}: {t('kd')} {amountVal}
              </p>
            </div>
          </div>

          <button
            className={`custom_btn custom_btn_primary btn_block`}
            disabled={validateLoadBalance?.isLoading}
            onClick={handleContinue}
          >
            {validateLoadBalance?.isLoading ? (
              <Loadingcomponent />
            ) : (
              t('continue')
            )}
          </button>
        </div>
      </section>
    </div>
  );
};

export default LoadBalance;
